// =====================================================================
// crmCustomer — Pilots: top-level page (the tab shell).
//
// The work lives in the sibling files:
//   pilots-shared.jsx   — status enum, pence helpers, checklist data
//   pilots-metrics.jsx  — Metrics tab + the PILOT_METRICS framework
//   pilots-list.jsx     — Pilots tab + New / Edit / Checklist / Log dialogs
//
// build.js + index.html load them in that order so the shell can pull
// PilotsMetricsTab and PilotsListTab off the global scope.
// =====================================================================

function PilotsPage({ navigate, initialTab }) {
  const validTab = (t) => t === "pilots" || t === "metrics" || t === "gatelog";
  const [tab, setTab] = useState(validTab(initialTab) ? initialTab : "metrics");
  // Cross-tab linkage: the List tab can push a pilot id into the
  // Gatelog tab via this state, narrowing the gate table to that pilot.
  const [gatelogFilterPilotId, setGatelogFilterPilotId] = useState(null);

  const pilotsCount = (D.PILOTS || []).length;
  const gatesCount  = (D.PILOT_GATES || []).length;
  const tabs = [
    { key: "metrics", label: "Metrics" },
    { key: "pilots",  label: "List",    count: pilotsCount },
    { key: "gatelog", label: "Gatelog", count: gatesCount  },
  ];
  const subs = {
    metrics: `${pilotsCount} pilot${pilotsCount === 1 ? "" : "s"} · live cohort scorecard`,
    pilots:  "Live pilots, their status, onboarding checklists and ongoing logs",
    gatelog: "Per-gate review records — maturity, value, risks, go/no-go, next action",
  };

  function openGatelogForPilot(pilotId) {
    setGatelogFilterPilotId(pilotId);
    setTab("gatelog");
  }

  return (
    <>
      <PageHead title="Pilots" sub={subs[tab]} />
      <Tabs tabs={tabs} current={tab} onChange={setTab} />
      {tab === "metrics" && <PilotsMetricsTab />}
      {tab === "pilots"  && <PilotsListTab navigate={navigate} onOpenGatelog={openGatelogForPilot} />}
      {tab === "gatelog" && <PilotsGatelogTab
        filterPilotId={gatelogFilterPilotId}
        onClearFilter={() => setGatelogFilterPilotId(null)} />}
    </>
  );
}

window.PilotsPage = PilotsPage;
